var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fast-fade", mode: "out-in" } }, [
    _c(
      "div",
      { staticClass: "grow" },
      [
        _c(
          "w-drawer",
          {
            staticClass: "main-drawer",
            attrs: { hover: _vm.$wf.isSmDown, "swipe-open": "" },
            model: {
              value: _vm.drawer,
              callback: function ($$v) {
                _vm.drawer = $$v
              },
              expression: "drawer",
            },
          },
          [
            _c("w-drawer-item", { staticClass: "mts", attrs: { to: "/" } }, [
              _c("span", { staticClass: "icon icon-arrow-left" }),
              _c("span", [_vm._v(_vm._s(_vm.$ct("back")))]),
            ]),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              { staticClass: "mts", attrs: { to: "/settings" } },
              [
                _c("span", { staticClass: "icon icon-settings-icons" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("default")))]),
              ]
            ),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              { staticClass: "mts", attrs: { to: "/settings/sales" } },
              [
                _c("span", { staticClass: "icon icon-bag-full" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("sales")))]),
              ]
            ),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              { staticClass: "mts", attrs: { to: "/settings/browse" } },
              [
                _c("span", { staticClass: "icon icon-window2" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("browses")))]),
              ]
            ),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              { staticClass: "mts", attrs: { to: "/settings/plugins" } },
              [
                _c("span", { staticClass: "icon icon-connection" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("plugins")))]),
              ]
            ),
            _c("w-divider"),
          ],
          1
        ),
        _c(
          "transition",
          { attrs: { name: "fast-fade", mode: "out-in" } },
          [_c("router-view")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }